import { IQuestionsGroupProps } from 'app/components/questions/base'
import { AutoQuestionsGroup } from 'app/containers/PipelineSection/Expenses/Auto'
import { OtherEntertainmentQuestionsGroup, TravelQuestionsGroup } from 'app/containers/PipelineSection/Expenses/Entertainment';
import { DiningOutQuestionsGroup, GroceriesQuestionsGroup } from 'app/containers/PipelineSection/Expenses/Food';
import { HomeInsuranceQuestionsGroup, HomeMaintanenceQuestionsGroup, MortgageQuestionsGroup, PropertyTaxesQuestionsGroup, UtilitiesQuestionsGroup } from 'app/containers/PipelineSection/Expenses/Home'
import { ExpensesIntro } from 'app/containers/PipelineSection/Expenses/Introduction'
import { MedicalQuestionsGroup } from 'app/containers/PipelineSection/Expenses/Medical'
import { CharityQuestionsGroup, SavingsDebtQuestionsGroup, TaxesQuestionsGroup } from 'app/containers/PipelineSection/Expenses/Other';
import { ClothingQuestionsGroup, WardrobeQuestionsGroup } from 'app/containers/PipelineSection/Expenses/Personal';
import { ExpensesSummary } from 'app/containers/PipelineSection/Expenses/Summary'

interface IExpenseQuestionGroups {
  ExpensesIntro: () => React.ReactElement<IQuestionsGroupProps>
  MortgageQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  PropertyTaxesQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  HomeInsuranceQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  HomeMaintanenceQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  UtilitiesQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  AutoQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  ExpensesSummary: () => React.ReactElement<IQuestionsGroupProps>
  GroceriesQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  DiningOutQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  ClothingQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  MedicalQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  WardrobeQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  TravelQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  OtherEntertainmentQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  CharityQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  TaxesQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
  SavingsDebtQuestionsGroup: () => React.ReactElement<IQuestionsGroupProps>
}

const ExpenseQuestionGroups: IExpenseQuestionGroups = {
  ExpensesIntro,
  MortgageQuestionsGroup,
  PropertyTaxesQuestionsGroup,
  HomeInsuranceQuestionsGroup,
  HomeMaintanenceQuestionsGroup,
  UtilitiesQuestionsGroup,
  AutoQuestionsGroup,
  ExpensesSummary,
  GroceriesQuestionsGroup,
  DiningOutQuestionsGroup,
  ClothingQuestionsGroup,
  MedicalQuestionsGroup,
  WardrobeQuestionsGroup,
  TravelQuestionsGroup,
  OtherEntertainmentQuestionsGroup,
  CharityQuestionsGroup,
  TaxesQuestionsGroup,
  SavingsDebtQuestionsGroup,
}

type ExpenseQuestionGroupsKeys = keyof IExpenseQuestionGroups

const genericChangeCTA = 'This expense will change during retirement'

export {
  ExpenseQuestionGroups,
  ExpenseQuestionGroupsKeys,
  genericChangeCTA
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/Expenses/index.ts